module.exports = __webpack_public_path__ + "static/media/background-pattern.60c8cdf3.png";